import { defineComponent as _defineComponent } from 'vue'
import type { FlashMessages } from '../types';
import { useWatchMessages } from '../composables/messages';
import {
    // @ts-ignore
    ModalsContainer,
} from 'vue-final-modal';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  props: {
    flash: null
  },
  setup(__props: any) {

const props = __props as { flash?: FlashMessages; };



useWatchMessages(() => props?.flash);

return { __sfc: true,props, ModalsContainer }
}

})